import { c as _c } from "react/compiler-runtime";
import { useFeatureFlag } from '@newfront-insurance/admin-ui';
import { useNewfrontLocalStorage } from '@newfront-insurance/react-hooks';
import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useMemo, useEffect } from 'react';
import Snowfall from 'react-snowfall';
interface SnowfallContextType {
  isSnowfallEnabled: boolean;
  toggleSnowfall: () => void;
}
const SnowfallContext = createContext<SnowfallContextType | undefined>(undefined);
export function SnowfallProvider(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const isSnowfallFeatureFlagEnabled = useFeatureFlag("snowfall", false);
  const [isSnowfallEnabled, setIsSnowfallEnabled] = useNewfrontLocalStorage("isSnowing", false);
  let t1;
  let t2;
  if ($[0] !== setIsSnowfallEnabled) {
    t1 = () => {
      const channel = new BroadcastChannel("snowfall-channel");
      channel.onmessage = event => {
        if (event.data.type === "TOGGLE_SNOWFALL") {
          setIsSnowfallEnabled(event.data.isEnabled);
        }
      };
      return () => channel.close();
    };
    t2 = [setIsSnowfallEnabled];
    $[0] = setIsSnowfallEnabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isSnowfallEnabled || $[4] !== setIsSnowfallEnabled) {
    t3 = () => {
      const newValue = !isSnowfallEnabled;
      setIsSnowfallEnabled(newValue);
      const channel_0 = new BroadcastChannel("snowfall-channel");
      channel_0.postMessage({
        type: "TOGGLE_SNOWFALL",
        isEnabled: newValue
      });
    };
    $[3] = isSnowfallEnabled;
    $[4] = setIsSnowfallEnabled;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toggleSnowfall = t3;
  let t4;
  const t5 = isSnowfallEnabled ?? false;
  let t6;
  if ($[6] !== t5 || $[7] !== toggleSnowfall) {
    t6 = {
      isSnowfallEnabled: t5,
      toggleSnowfall
    };
    $[6] = t5;
    $[7] = toggleSnowfall;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  t4 = t6;
  const value = t4;
  let t7;
  if ($[9] !== isSnowfallEnabled || $[10] !== isSnowfallFeatureFlagEnabled) {
    t7 = isSnowfallFeatureFlagEnabled && isSnowfallEnabled && <Snowfall />;
    $[9] = isSnowfallEnabled;
    $[10] = isSnowfallFeatureFlagEnabled;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== t7 || $[14] !== value) {
    t8 = <SnowfallContext.Provider value={value}>{children}{t7}</SnowfallContext.Provider>;
    $[12] = children;
    $[13] = t7;
    $[14] = value;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
export function useSnowfall() {
  const context = useContext(SnowfallContext);
  if (context === undefined) {
    throw new Error("useSnowfall must be used within a SnowfallProvider");
  }
  return context;
}